import styled from 'styled-components';
import { DEVICES } from '../../config/appConfig';

export const StyledCardWrapper = styled.div`
  width: ${({ cardsPerRow }) => `calc(100% / ${cardsPerRow} - 14px)`};
  min-height: 180px;
  border-radius: 20px;
  box-shadow: 0px 12px 12px 0px rgba(0, 0, 0, 0.09);
  padding: 20px;
  background-color: #fff;

  @media ${DEVICES.tablet} {
    width: calc(100% / 3 - 14px);
  }

  @media ${DEVICES.mobile} {
    width: calc(100% / 2 - 14px);
  }

  @media ${DEVICES.sMobile} {
    width: calc(100% / 1 - 14px);
  }
`;
